import React from "react"
import { useStaticQuery, Link, graphql } from "gatsby"

const ListLink = props => (
  <li className={`menu-item ${props.children.toLowerCase()}`}>
    <Link to={props.to}>{props.children}</Link>
  </li>
)

export default ({ children }) => {
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
          }
        }
      }
    `
  )
  return (
  <main class="wide">
    <header>
      <ul>
        <ListLink to="/wam1f26/">☻</ListLink>
        <ListLink to="/wam1f26/project/">Projects and Exercises</ListLink>
        <ListLink to="/wam1f26/readings/">Readings</ListLink>
        <ListLink to="/wam1f26/meeting/">Meeting</ListLink> 
        <ListLink to="/wam1f26/resource/">Resource</ListLink> 
        <ul class="menu-right">
          {/* <ListLink to="/gdfwf20/meetings/">Meetings</ListLink> */}
          <ListLink to="/wam1f26/topics/">Topics</ListLink>
          <ListLink to="/wam1f26/syllabus/">Syllabus</ListLink>
          {/* <ListLink to="/wam1f26/colophon/" className="colophon">Colophon</ListLink> */}
          </ul>
      </ul>
    </header>
    {children} 
  </main>
  )
}
